import config from 'config'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { footerActions } from 'srcReact/Footer'

import styles from './styles.module.scss'
import Spinner from 'srcReact/components/common2/Spinner'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'

const FooterContainer = ({ isMobile, t, newsletter, user, loggedIn, subscribeNewsletter }) => {
  const [email, setEmail] = useState('')
  const [submittedNL, setSubmittedNL] = useState(false)

  const handleChangeEmail = (e) => {
    const { value } = e.target
    setEmail(value)
  }

  const handleNewsletterSubmit = (e) => {
    e.preventDefault()

    setSubmittedNL(true)
    if (email) {
      subscribeNewsletter(email)
      setSubmittedNL(false)
      setEmail('')
    } else {
      setSubmittedNL(false)
    }
  }

  const urlAbout = `${config.webUrl}/communities-at-work/learn-more/about`
  const urlSupport = isUserAuthorized() ? `${config.webUrl}/0/support` : `${config.webUrl}/contact-us`

  const menu = [
    {
      // link: isUserAuthorized() ? `${config.webUrl}/` : `${config.webUrl}/communities-at-work`,
      link: isUserAuthorized() ? `${config.webUrl}/` : 'https://community.mixr.net/',
      text: t('footer.link0')
    },
    {
      link: `https://community.mixr.net/product`,
      text: t('footer.link1')
    },
    {
      link: urlAbout,
      text: t('footer.link2')
    },
    {
      link: `${config.webUrl}/blog/communities`,
      text: t('footer.link3')
    },
    {
      link: `${config.webUrl}/communities-at-work/learn-more/press`,
      text: t('footer.press')
    },
    {
      link: urlSupport,
      text: t('footer.link4')
    }
  ]

  const menulist = menu.map((e, i) => (
    <li key={i}>
      <a href={e.link} className={styles.menuLink}>
        {e.text}
      </a>
    </li>
  ))

  const menu2 = [
    {
      link: `${config.webUrl}/communities-at-work/community-guidelines`,
      text: t('footer.link5')
    },
    {
      link: `${config.webUrl}/communities-at-work/privacy-policy`,
      text: t('footer.link6')
    },
    {
      link: `${config.webUrl}/communities-at-work/terms-of-services`,
      text: t('footer.link7')
    },
    {
      link: 'https://mixr-knowledge-base.mixr.net',
      text: t('footer.link8')
    }
  ]

  const menulist2 = menu2.map((e, i) => (
    <li key={i}>
      <a href={e.link} className={styles.menuLink}>
        {e.text}
      </a>
    </li>
  ))

  const social = [
    {
      slug: 'linkedin',
      title: 'Linkedin',
      url: 'https://www.linkedin.com/company/mixr-event/'
    },
    {
      slug: 'instagram',
      title: 'Instagram',
      url: 'https://www.instagram.com/mixrsocial/'
    },
    {
      slug: 'twitter',
      title: 'Twitter',
      url: 'https://twitter.com/mixrsocial/'
    }
  ]
  const socialList = social.map((e, i) => (
    <a key={i} href={e.url} target='_blank' className={`${styles.mixrIcon} ${styles[e.slug]}`}></a>
  ))

  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.mainRow}>
          <ul className={styles.menu1Container}>{menulist}</ul>
          <ul className={styles.menu2Container}>{menulist2}</ul>
          <div className={styles.socialContainer}>
            <div className={styles.socialTitle}>Follow us</div>
            <div className={styles.socialContainer2}>{socialList}</div>
          </div>
          <div className={styles.formContainer}>
            <div className={styles.strongTitle}>{t('footer.newsletter')}</div>
            {!submittedNL && newsletter && newsletter.success && (
              <p className={styles.newsLetterSuccess}>{t('footer.nl_success')}</p>
            )}
            <form className={styles.form} name='formNewsletter' onSubmit={handleNewsletterSubmit}>
              <div className={styles.inputContainer}>
                <input
                  type='email'
                  name='email'
                  placeholder={isMobile ? t('footer.placeholderMobile') : t('footer.placeholder')}
                  className={styles.formInput}
                  onChange={handleChangeEmail}
                />
              </div>
              <div className={styles.submitContainer}>
                <button type='submit' className={styles.formButton}>
                  {newsletter && newsletter.submitted ? <Spinner isWhite={true} /> : t('footer.subscribe')}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className={styles.copyrightContainer}>
          {t('footer.text1')}
          <br />
          {t('footer.text2')}
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state) => {
  const {
    common: { isMobile },
    login: { user, loggedIn },
    footer: { newsletter }
  } = state

  return { isMobile, newsletter, user, loggedIn }
}

const actionCreators = {
  subscribeNewsletter: footerActions.subscribeNewsletter
}

const ExtendedComponent = withTranslation('common')(FooterContainer)

const connectedFooterContainer = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedFooterContainer as FooterContainer }
